
const authentification = {
    'authentification.signIn': 'Prihlásenie',
    'authentification.email': 'Email',
    'authentification.password': 'Heslo',
}

const sideNav = {
    'sideNav.home': 'Domov',
    'sideNav.announcements': 'Upozornenia',
    'sideNav.users': 'Používatelia',
    'sideNav.userEdit': 'Zmena osobných údajov',
    'sideNav.inventory': 'Inventár',
    'sideNav.containersTable': 'Kontajnery',
    'sideNav.containerDetail': 'Kontajner detail',
    'sideNav.paymentsTable': 'Platby',
    'sideNav.ordersTable': 'Plavby',
    'sideNav.orderDetail': 'Objednávka detail',
    'sideNav.reservationsTable': 'Rezervácie',
    'sideNav.reservationDetail': 'Rezervácia detail',
    'sideNav.priceList': 'Cenník',
    'sideNav.logOut': 'Odhlásiť sa',
    'sideNav.signIn': 'Prihlásenie',
}

const homePage = {
    'homePage.users': 'Používatelia',
    'homePage.users.bodyName': 'za posledný mesiac',
    'homePage.orders': 'Aktívne objednávky',
    'homePage.orders.bodyName': 'za 24 hodín',
    'homePage.orders.footerName': 'Objednávky za mesiac',
    'homePage.income': 'Tržby za',
    'homePage.income.bodyName': 'za predošlý deň ',
    'homePage.inTransit': 'Lode v teréne',
    'homePage.reservations': 'Rezervácie',
    'homePage.reservations.bodyName': 'za 24 hodín',
    'homePage.containers': 'Kontajnery',
    'homePage.name': 'Názov',
    'homePage.tooltip.availableBoats': 'Dostupné lode',
    'homePage.tooltip.reservedBoats': 'Rezervované lode na zajtra',
    'homePage.tooltip.onlineSignal': 'online',
    'homePage.tooltip.offlineSignal': 'offline',
    'homePage.legend.numOfKayaks': 'Kajaky v kontajnery',
    'homePage.legend.reservations': 'Rezervované kajaky',
    'homePage.legend.numOfKayaksReservations': 'Čaká, Schválená, Pripravená rezervácia',
}

const announcements = {
    'announcements.title.currentAnnouncement': 'Aktuálne upozornenie',
    'announcements.note': 'Zverejnením nového upozornenia nahradíte aktuálne upozornenie.',
    'announcements.templates': 'Šablóny',
    'announcements.title.removeModal': 'Upozornenie bude odstránené',
}

const tableUsers = {
    'tableUsers.title': 'Používatelia',
    'tableUsers.id': 'Id',
    'tableUsers.firstName': 'Meno',
    'tableUsers.lastName': 'Priezvisko',
    'tableUsers.fullName': 'Meno Priezvisko',
    'tableUsers.email': 'Email',
    'tableUsers.phone': 'Telefón',
    'tableUsers.country': 'Krajina',
    'tableUsers.blockedAt': 'Status',
    'tableUsers.blockedAt.null': 'Aktívny',
    'tableUsers.blockedAt.block': 'Blokovaný',
    'tableUsers.blockedAt.clear': 'Zrušiť výber',
}

const userProfile = {
    'userProfile.title': 'Profil používateľa',
    'userProfile.personalInfo': 'Osobné Údaje',
    'userProfile.id': 'Id používateľa:',
    'userProfile.firstname': 'MENO',
    'userProfile.surname': 'PRIEZVISKO',
    'userProfile.email': 'EMAIL',
    'userProfile.mobil': 'TELEFÓNNE ČÍSLO',
    'userProfile.street': 'ULICA',
    'userProfile.city': 'MESTO',
    'userProfile.postal': 'PSČ',
    'userProfile.country': 'KRAJINA',
    'userProfile.status': 'STAV',
    'userProfile.freeOfCharge': 'BEZPLATNÝ REŽIM',
    'userProfile.freeOfCharge.false': 'Neaktívny',
    'userProfile.freeOfCharge.true': 'Aktívny',
    'userProfile.sumReg': 'POČET REZERVÁCII',
    'userProfile.resLastMonth': 'REZERVÁCIE',
    'userProfile.registeredAt': 'DÁTUM REGISTRÁCIE',
}

const userEdit = {
    'userEdit.personalInfo': 'Osobné Údaje',
    'userEdit.id': 'Id používateľa:',
    'userEdit.name': 'Meno',
    'userEdit.surname': 'Priezvisko',
    'userEdit.street': 'Ulica',
    'userEdit.city': 'Mesto',
    'userEdit.postal': 'PSČ',
}

const tableInventory = {
    'tableInventory.title': 'Inventár',
    'tableInventory.id': 'Id',
    'tableInventory.type': 'Typ',
    'tableInventory.variant': 'Veľkosť',
    'tableInventory.containerId': 'Kontajner-Id',    
    'tableInventory.containerName': 'Kontajner-Meno',
    'tableInventory.status': 'Stav',
    'tableInventory.statusTrue': 'V prevádzke',
    'tableInventory.statusFalse': 'Mimo prevádzky',
    'tableInventory.notes': 'Poznámka',
    'tableInventory.kayak': 'Loď',
    'tableInventory.vest': 'Vesta',
    'tableInventory.helmet': 'Prilba',
    'tableInventory.bag': 'Vak',
    'tableInventory.paddle': 'Pádlo',
    'tableInventory.batteryStatusTitle': 'Batéria',
    'tableInventory.batteryStatusFull': 'Nabitá',
    'tableInventory.batteryStatusEmpty': 'Vybitá',
    'tableInventory.noImage': 'Žiadny obrázok',
    'tableInventory.location': 'Stav',
    'tableInventory.container': 'Kontajner',
    'tableInventory.unknown': 'Sklad',
    'tableInventory.cruise': 'Vypožičaný',
    'tableInventory.lastSeenAt': 'HeartBeat',
    'tableInventory.boatId': 'ID lode',
    'tableInventory.beaconMac': 'Beacon MAC',
}

const tableItems = {
    'tableItems.title': 'Položky',
    'tableItems.id': 'Id',
    'tableItems.type': 'Typ',
    'tableItems.notes': 'Poznámka',
}

const inventory = {
    'inventory.edit.title': 'Príslušenstvo',
    'inventory.edit.type': 'Typ',
    'inventory.edit.status': 'Stav',
    'inventory.edit.variant': 'Veľkosť',
    'inventory.edit.notes': 'Poznámka',
    'inventory.edit.idBoat': 'ID lode',
}

const tableContainers = {
    'tableContainers.title': 'Kontajnery',
    'tableContainers.id': 'Id',
    'tableContainers.name': 'Názov',
    'tableContainers.isEnabled': 'Prevádzka',
    'tableContainers.isEnabledTrue': 'V prevádzke',
    'tableContainers.isEnabledFalse': 'Mimo prevádzky',
    'tableContainers.capacity': 'Kapacita',
    'tableContainers.equipmentCount': '∑ Spolu',
    'tableContainers.boatsCount': 'Lode',
    'tableContainers.doorStatusA': 'Dvere A',
    'tableContainers.doorStatusB': 'Dvere B',
    'tableContainers.door.open': 'Otvorené',
    'tableContainers.door.close': 'Zatvorené',
    'tableContainers.status': 'Stav',
    'tableContainers.status.online': 'Online',
    'tableContainers.status.offline': 'Offline',
    'tableContainers.doors': 'Dvere',
    'tableContainers.door.warning': 'Otvorené pridlho',
    'tableContainers.door.unknown': 'Neznámy stav',
    
    'tableContainers.tooltip.doorWarningHomePage': 'Otvorené',
    'tableContainers.tooltip.doorWarning': 'Otvorené v bežnom trvaní',
    'tableContainers.tooltip.doorSuccess': 'Zatvorené',
    'tableContainers.tooltip.doorError': 'Otvorené pridlho - varovanie',
    'tableContainers.tooltip.unknown': 'Neznámy stav',
    
    'tableContainers.warehouses.title': 'Sklady',
    'tableContainers.warehouses.mainWarehouse': 'Centrálny sklad',
    'tableContainers.warehouses.loans': 'Výpožičky',
    
    'tableContainers.modal.title': 'Upraviť čas upozornenia',
    'tableContainers.modal.currentTime': 'Aktuálny nastavený čas je {currentTime} min.',
    'tableContainers.modal.placeholder': 'Čas v minútach',
}

const detailContainer = {
    'containerInfo.info': 'Informácie',
    'containerInfo.id': 'ID:',
    'containerInfo.name': 'MENO KONTAJNERU',
    'containerInfo.status': 'Pripojenie',
    'containerInfo.pin': 'PIN',
    'containerInfo.inventory': 'Inventár',
    'containerInfo.kayak': 'POČET KAJAKOV',
    'containerInfo.equipments': 'POČET VYBAVENIA',
    'containerInfo.isEnabled': 'Prevádzka',
    'containerInfo.doorA': 'Dvere A',
    'containerInfo.doorB': 'Dvere B',
    'containerInfo.boats': 'Lode',
    'containerInfo.paddle': 'Pádla',
    'containerInfo.bag': 'Vaky',
    'containerInfo.vest': 'Vesty',
    'containerInfo.helmet': 'Prilby',
    'containerInfo.size': 'Veľkosť',
    'containerInfo.openContainer': 'Otvorené v bežnom trvaní',
    'containerInfo.openContainerWarning': 'Otvorené pridlho - varovanie po {warningTime}min.',
    'containerInfo.unknown': 'Neznámy stav',
    'containerInfo.closedContainer': 'Zatvorené',
    'containerInfo.lastOnline': 'Naposledy online',
    'containerInfo.reservationLegendFirstRow': '8-10 hod.',
    'containerInfo.reservationLegendSecondRow': '13-15 hod.',
    'containerInfo.reservationLegendReservationCapacity': 'Rezervované/Kapacita',
    
    'containerReservation.title': 'Rezervácie',
}

const tablePayments = {
    'tablePayments.title': 'Platby',
    'tablePayments.user.title': 'Platby používateľa',
    'tablePayments.id': 'Id',
    'tablePayments.user': 'Používateľ',
    'tablePayments.status': 'Stav',
    'tablePayments.createdAt': 'Vytvorená',
    'tablePayments.finishedAt': 'Ukončená',
    'tablePayments.type': 'Typ',
    'tablePayments.amount': 'Suma',
    'tablePayments.price': 'Cena',
    'tablePayments.penalty': 'Pokuta',
    'tablePayments.exportPayments': 'Exportovať platby',

    'tablePayments.status.pending': 'Čaká',
    'tablePayments.status.processing': 'Prebieha platba',
    'tablePayments.status.successful': 'Úspešná',
    'tablePayments.status.expired': 'Platnosť vypršala',
    'tablePayments.status.failed': 'Neúspešná',    

    'tablePayments.type.standard': 'Štandardná',
    'tablePayments.type.verification': 'Overenie',    
    'tablePayments.type.new_card': 'Nová karta',    
    'tablePayments.type.fine': 'Pokuta',    
    
    'tablePaymentsInOrder.typeStandard': 'Platba',    
    'tablePaymentsInOrder.typeFine': 'Dodatočné poplatky',    
    'tablePaymentsInOrder.amount': 'Hodnota',    
    'tablePaymentsInOrder.description': 'Popis',    
    'tablePaymentsInOrder.status': 'Stav',    
}

const tableOrders = {
    'tableOrders.title': 'Plavby',
    'tableOrders.user.title': 'Objednávky používateľa',
    'tableOrders.id': 'Id',
    'tableOrders.fullName': 'Používateľ',
    'tableOrders.createdAt': 'Vytvorená',
    'tableOrders.completedAt': 'Dokončená',
    'tableOrders.startPlace': 'Začiatok',
    'tableOrders.status': 'Stav',
    'tableOrders.paymentStatus': 'Stav platby',
    'tableOrders.rezervation': 'Rezervácie',
    'tableOrders.price': 'Cena',
    'tableOrders.penalty': 'Pokuta',
    'tableOrders.amountFine': 'Výška pokuty',
}

const orderDetail = {
    'order.detail.title': 'Plavba',
    'order.detail.id': 'Id objednávky',
    'order.detail.idOrder': 'Id Objednávky',
    'order.detail.user': 'Používateľ',
    'order.detail.status': 'Stav',
    'order.detail.payment': 'Platba',
    'order.detail.price': 'Cena',
    'order.detail.isFreeOfCharge': 'BEZPLATNÝ REŽIM',
    'order.detail.createdAt': 'Vytvorená',
    'order.detail.cancel': 'Zrušiť platbu',
    'order.detail.close': 'Uzavrieť platbu',
    
    'order.detail.in_progress': 'Prebieha plavba',
    'order.detail.awaiting_payment': 'Čaká na platbu',
    'order.detail.completed': 'Dokončená',
    'order.detail.cancelled': 'Zrušená',
    
    'order.detail.startPlace': 'Začiatok',
    'order.detail.finishPlace': 'Koniec',
    'order.detail.title.fees': 'Poplatky',
    
    'order.popup.title': 'Manuálne ukončenie plavby',
    'order.popup.endedAt': 'Čas ukončenia HH:MM',
    'order.popup.price': 'Cena',
}

const tableReservations = {
    'tableReservations.title': 'Rezervácie',
    'tableReservations.id': 'Id',
    'tableReservations.user': 'Používateľ',
    'tableReservations.startAt': 'Začiatok',
    'tableReservations.boatsCount': 'Počet lodí',
    'tableReservations.place': 'Začiatok plavby',
    'tableReservations.status': 'Stav',
    
    'tableReservations.pending': 'Čaká',
    'tableReservations.approved': 'Schválená',
    'tableReservations.rejected': 'Zamietnutá',
    'tableReservations.cancelled': 'Zrušená A',
    'tableReservations.cancelledByCustomer': 'Zrušená P',
    'tableReservations.ready': 'Pripravená',
    'tableReservations.completed': 'Realizovaná',
    'tableReservations.newRes': 'Nové rezervácie',
    'tableReservations.nextDayRes': 'Nasledujúci deň',
    'tableReservations.fineRes': 'Kandidát na doplnkový poplatok.',
    'tableReservations.phone': 'Telefón',
    // 'tableReservations.completed': 'Pripravená',
}

const reservationDetail = {
    'reservationDetail.title': 'Rezervácia',
    'reservationDetail.id': 'ID',
    'reservationDetail.userFirstName': 'MENO',
    'reservationDetail.userLastName': 'PRIEZVISKO',
    'reservationDetail.mobil': 'TELEFÓN',
    'reservationDetail.email': 'EMAIL',
    'reservationDetail.place': 'Začiatok plavby',
    'reservationDetail.boatsCount': 'POČET LODÍ',
    'reservationDetail.statusReservation': 'STAV REZERVÁCIE',
    'reservationDetail.dateTime': 'Dátum a čas',
    'reservationDetail.requiredBoats': 'Požadované lode',
    
    'reservationDetail.createdAt': 'VYTVORENÁ',
    'reservationDetail.startAt': 'ZAČIATOK',
    'reservationDetail.cancelledAt': 'ČAS ZRUšENIA',
    'reservationDetail.status': 'Stav',

    'reservationDetail.StatusPending': 'Čaká na vyjadrenie',
    'reservationDetail.StatusCancelledByCustomer': 'Zrušená používateľom',
    'reservationDetail.StatusCancelledByAdmin': 'Zrušená Administrátorom',
    
    'reservationDetailFine.title': 'Poplatky',
    'reservationDetailFine.status': 'STAV POKUTY',
    'reservationDetailFine.amount': 'VÝŠKA POKUTY',
    'reservationDetailFine.description': 'Popis',
    'reservationDetailFine.createdAt': 'VYTVORENÁ',
    'reservationDetailFine.price': 'Poplatok',
    
    'reservationEdit.title': 'Upraviť rezerváciu',
    'reservationEdit.id': 'Id',
    'reservationEdit.pending': 'Čaká',
    'reservationEdit.rejected': 'Zamietnuť',
    'reservationEdit.approved': 'Potvrdiť',
    'reservationEdit.cancelled': 'Zrušiť',
    'reservationEdit.addFine': 'Áno',
    'reservationEdit.noAddFine': 'Nie',
    'reservationEdit.fine': 'Pridať pokutu',
    'reservationEdit.date': 'Dátum',
    'reservationEdit.time': 'Čas',
    
    'reservationDetailModal.fine': 'Naozaj chcete pridať pokutu'
}

const finesTable = {
    'fines.detail.title': 'Pokuty',
    'fines.detail.id': 'Id',
    'fines.detail.status': 'Stav',
    'fines.detail.amount': 'Cena',
    'fines.detail.description': 'Popis',

    'fines.detail.awaiting_payment': 'Čaká na platbu',
    'fines.detail.paid': 'Zaplatená',
    
    'fines.addFine': 'Dodatočné poplatky',  
    'fines.order': 'Objednávka',  
    'fines.feeAmount': 'Výška poplatku',  
}

const equipmentsOrderTable = {
    'equipmentsOrder.title': 'Položky',
    'equipmentsOrder.id': 'Id',
    'equipmentsOrder.name': 'Typ',
    'equipmentsOrder.status': 'Stav',
    'equipmentsOrder.price': 'Cena',
    'equipmentsOrder.rentPlace': 'Požičané',
    'equipmentsOrder.returnPlace': 'Vrátené',
    'equipmentsOrder.variant': 'Veľkosť',

    'equipmentsOrder.rented': 'Požičané',
    'equipmentsOrder.returned': 'Vrátené',
}

const priceList = {
    'priceList.title': 'Cenník',
    'priceList.kayak': 'Loď 2-miestna',
    'priceList.cayakThreePerson': 'Loď 3-miestna',
    'priceList.paddle': 'Pádlo',
    'priceList.helmet': 'Prilba',
    'priceList.vest': 'Vesta',
    'priceList.bag': 'Vak',
    'priceList.openContainer': 'Otvorený kontajner',
    'priceList.reservationFine': 'Zrušená rezervácia',
    'priceList.item': 'Položka',
    'priceList.rent': 'Požičovné',
    'priceList.rentOneHour': 'Prvá hodina',
    'priceList.rentNextHour': 'Ďalšia hodina',
    'priceList.lost': 'Strata',
    'priceList.damage': 'Poškodenie',
}

const table = {
    'table.actions': 'Akcie',
    'table.showing': 'Zobrazuje sa',
    'table.to': 'až',
    'table.of': 'z',
    'table.items': 'položiek',
    'table.itemsPerPage': 'položiek na stránku',
}


const button = {
    'button.addUser': 'PRIDAŤ POUŽÍVATEĽA',
    'button.addItem': 'PRIDAŤ POLOŽKU',
    'button.add': 'PRIDAŤ',
    'button.change': 'Upraviť',
    'button.delete': 'Odstrániť',
    'button.picture': 'Obrázok',
    'button.block': 'Blokovať',
    'button.unblock': 'Odblokovať',
    'button.active': 'Aktivovať',
    'button.deactive': 'Deaktivovať',
    'button.blockUser': 'Blokovať používateľa',
    'button.unblockUser': 'Odblokovať používateľa',
    'button.blockCharges': 'Aktivovať bezplatný režim',
    'button.unblockCharges': 'Deaktivovať bezplatný režim',
    'button.detail': 'Detail',
    'button.cancel': 'ZRUŠIŤ',
    'button.select': 'ZVOLIŤ',
    'button.save': 'ULOŽIŤ',
    'button.back': 'NASPÄŤ',
    'button.photo': 'Fotografia',
    'button.dateRange': 'Potvrdiť dátum',
    'button.changeCurrentAnnouncement': 'Upraviť zverejnenie',
    'button.addNewAnnouncement': 'Pridať zverejnenie',
    'button.useAnnouncement': 'Použiť',
    'button.containerOutOfOrder': 'VYRADIŤ Z PREVÁDZKY',
    'button.containerActivate': 'AKTIVOVAŤ PREVÁDZKU',
    'button.changeWarningTime': 'UPRAVIŤ ČAS VAROVANIA',
    'button.submitCloseOrder': 'POTVRDIŤ UKONČENIE',
    'button.changeTime': 'UPRAVIŤ ČAS',
    'button.closeOrder': 'UKONČIŤ',
    'button.cancelOrder': 'STORNO',
    'button.addFines': 'PRIDAŤ POPLATOK',
    'button.rejected': 'ZAMIETNUŤ',
    'button.approved': 'SCHVÁLIŤ',
    'button.ready': 'PRIPRAVENÁ',
    'button.addAnnouncement': 'Zverejniť',
    'button.editAnnouncement': 'Upraviť šablónu',
    'button.removeCurrentAnnouncement': 'Odstrániť zverejnenie',
}

const alerts = {
    'userAlert.signIn.invalidToken': 'Neplatný token',
    'userAlert.signIn.expiredToken': 'Platnosť prihlásenia vypršala',
    'userAlert.signIn.server': ' Žiadna odozva servera',
    'userAlert.signIn.failed': 'Prihlásenie zlyhalo',
    'userAlert.signIn.wrongRole': 'Na prihlásenie je potrebný email administrátora',
    'userAlert.signIn.alert': 'Na email vám bol odoslaný link, cez ktorý sa prihlásite do aplikácie.',
    'userAlert.block': 'Používateľ bol zablokovaný',
    'userAlert.blockError': 'Používateľa sa nepodarilo zablokovať',
    'userAlert.unblock': 'Používateľ bol odblokovaný',    
    'userAlert.unblockError': 'Používateľa sa nepodarilo odblokovať',
    'userAlert.freeCharge': 'Bezplatný režim bol deaktivovaný',
    'userAlert.freeChargeError': 'Bezplatný režim sa nepodarilo deaktivovať',
    'userAlert.charge': 'Bezplatný režim bol aktivovaný',    
    'userAlert.chargeError': 'Bezplatný režim sa nepodarilo aktivovať',
    'userAlert.editUser.true': 'Používateľ bol zmenený',
    'userAlert.editUser.false': 'Používateľa sa nepodarilo zmeniť',
    'userAlert.editUser.emptyField': 'Vyplňte prosím všetky poľia',
    'userAlert.removeUser': 'Účet používateľa sa podarilo vymazať',
    'userAlert.removeUser.false': 'Účet používateľa sa nepodarilo vymazať',
    
    'inventoryAlert.status.true': 'Stav položky bol zmenený',
    'inventoryAlert.status.false': 'Stav položky sa nepodarilo zmeniť',

    'inventoryAlert.edit.true': 'Položka bola zmenená',
    'inventoryAlert.edit.false': 'Položku sa nepodarilo zmeniť',
    'inventoryAlert.edit.empty': 'Nebolo nič pridané alebo zmenené',
    
    'containerAlert.editEnabled.true': 'Stav kontajneru bol zmenený',
    'containerAlert.editEnabled.false': 'Stav kontajneru sa nepodarilo zmeniť',
    'containerAlert.editDoorWarningTime.true': 'Čas varovania bol zmenený',
    'containerAlert.editDoorWarningTime.false': 'Čas varovania sa nepodarilo zmeniť',
    'containerAlert.editDoorWarningTime.empty': 'Čas nie je vyplnený alebo rovnaký ako je aktuálne nastavený',
    
    'pricesAlert.edit.true': 'Cenník bol úspešne zmenený',
    'pricesAlert.edit.false': 'Cenník sa nepodarilo zmeniť',
    
    'finesAlert.add.true': 'Pokuta bola úspešne pridaná',
    'finesAlert.add.false': 'Pokutu sa nepodarilo pridať',
    'finesAlert.addAmount.false': 'Výška pokuty musí byť vyplnená',
    'finesAlert.addDescription.false': 'Popis musí byť vyplnený',
    'finesAlert.addDescriptionAmount.false': 'Popis a výška pokuty musia byť vyplnené',
    'finesAlert.addDescriptionAmountTime.false': 'Popis, cena a čas musia byť vyplnené',
    
    'orderAlert.closeOrder.true': 'Objednávka bola uzavretá',
    'orderAlert.closeOrder.false': 'Objednávku sa nepodarilo uzavtvoriť',
    'orderAlert.cancelOrder.true': 'Objednávka bola zrušená',
    'orderAlert.cancelOrder.false': 'Objednávku sa nepodarilo zrušiť',
    
    'reservationEditAlert.success': 'Rezervácia bola upravená',
    'reservationEditAlert.error': 'Rezerváciu sa nepodarilo upraviť',
    'reservationEditAlert.empty': 'Vyplňte prosím stav rezervácie',
    'reservationEditAlert.emptyFine': 'Vyplňte prosím pridanie pokuty',
    'reservationEditAlert.fine': 'Pokuta bola pridaná',
    'reservationEditAlert.fineError': 'Pokutu sa nepodarilo pridať',
    'reservationEditAlert.nothingChanged': 'Nebolo nič zmenené',

    'appAnnouncementAlert.add.true': 'Upozornenie bolo úspešne pridané',
    'appAnnouncementAlert.add.false': 'Upozornenie sa nepodarilo pridať',
    'appAnnouncementAlert.remove.true': 'Upozornenie bolo úspešne odstránené',
    'appAnnouncementAlert.remove.false': 'Upozornenie sa nepodarilo odstrániť',
    'appAnnouncementAlert.emptyInput': 'Vyplňte prosím text upozornenia',
    'appAnnouncementTemplateAlert.edit.true': 'Šablóna bola úspešne zmenená',
    'appAnnouncementTemplateAlert.edit.false': 'Šablónu sa nepodarilo zmeniť',
} 

const others = {
    'user.remove': 'Naozaj chcete odstrániť používateľa?',
    'loading': 'Načítavam...',
    'exportPaymentsTitle': 'Zvoľte obdobie za ktoré chcete exportovať platby',
    'exportPayments': 'Exportovať platby',
    'blockUser': 'Naozaj chcete blokovať používateľa ?',
    'unblockUser': 'Naozaj chcete aktivovať používateľa ?',
    'blockCharges': 'Naozaj chcete aktivovať bezplatný režim ?',
    'unblockCharges': 'Naozaj chcete deaktivovať bezplatný režim ?',
    'datePicker': 'Vyberte časové obdobie',
    'currency': '\u20AC',
    'errorLoadData': 'Nepodarilo sa načítať dáta. Skúste to prosím neskôr.',
}

const datePicker = {
    'datePicker.startDate': 'Dátum od',
    'datePicker.endDate': 'Dátum do',
    'datePicker.today': 'Dnes',
    'datePicker.yesterday': 'Včera',
    'datePicker.thisWeek': 'Tento týždeň',
    'datePicker.lastWeek': 'Minulý týždeň',
    'datePicker.last7days': 'Posledných 7 dní',
    'datePicker.thisMonth': 'Tento mesiac',
    'datePicker.lastMonth': 'Minulý mesiac',
    'datePicker.jan': 'Jan',
    'datePicker.feb': 'Feb',
    'datePicker.mar': 'Mar',
    'datePicker.apr': 'Apr',
    'datePicker.may': 'Máj',
    'datePicker.june': 'Jún',
    'datePicker.july': 'Júl',
    'datePicker.aug': 'Aug',
    'datePicker.sept': 'Sept',
    'datePicker.okt': 'Okt',
    'datePicker.nov': 'Nov',
    'datePicker.dec': 'Dec',
}

const messages = {
    ...authentification,
    ...sideNav,
    ...homePage,
    ...announcements,
    ...tableUsers,
    ...userProfile,
    ...userEdit,
    ...tableInventory,
    ...inventory,
    ...tableItems,
    ...tableContainers,
    ...detailContainer,
    ...tablePayments,
    ...tableOrders,
    ...orderDetail,
    ...tableReservations,
    ...reservationDetail,
    ...finesTable,
    ...equipmentsOrderTable,
    ...priceList,
    ...datePicker,
    ...table,
    ...button,
    ...alerts,
    ...others,
};

export default messages;